module.exports = __webpack_public_path__ + "files/9a279314ff73aaa8d28fce8f518a7147.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/smileys_emotion-3.png
// module id = 497
// module chunks = 76